import _ from 'underscore';

function isDFMEnabledForOverview(serverContext, campaignType) {
  return (campaignType === 'PerformanceMax' && serverContext.DynamicPermissions.PMaxLite)
    || !(window.location.search.indexOf('campaignId') > -1);
}

function getDFMEnabledPaths(serverContext, campaignType) {
  const DFMEnabledPaths = _.compact([
    '/campaign/vnext/campaigns',
    // TODO: enable DFM for campaign scope
    isDFMEnabledForOverview(serverContext, campaignType) ? '/campaign/vnext/overview' : '',
    '/campaign/vnext/accounts/overview',
    '/campaign/vnext/accounts/overview/expert',
    '/campaign/vnext/accounts/overview/smart',
    '/campaign/vnext/accounts/performance',
    '/campaign/vnext/createcampaign/objective',
    '/campaign/vnext/createcampaign/searchshopping',
    '/campaign/vnext/create-campaign/msstoreads',
    '/campaign/vnext/createcampaign/audienceshopping',
    // TODO: will change recommendation related routing to lower case
    '/campaign/vnext/recommendations/All',
    '/campaign/vnext/recommendations/Repairs',
    '/campaign/vnext/recommendations/Bids',
    '/campaign/vnext/recommendations/Keywords',
    '/campaign/vnext/recommendations/Ads',
    '/campaign/vnext/recommendations/Dismissed',
    '/campaign/vnext/recommendations/all',
    '/campaign/vnext/recommendations/repairs',
    '/campaign/vnext/recommendations/bids',
    '/campaign/vnext/recommendations/keywords',
    '/campaign/vnext/recommendations/ads',
    '/campaign/vnext/recommendations/dismissed',
    '/campaign/vnext/accounts/recommendations/All',
    '/campaign/vnext/accounts/recommendations/all',
    '/campaign/vnext/accounts/recommendations/repairs',
    '/campaign/vnext/accounts/recommendations/bids',
    '/campaign/vnext/accounts/recommendations/keywords',
    '/campaign/vnext/accounts/recommendations/ads',
    '/campaign/vnext/accounts/recommendations/dismissed',
    '/campaign/vnext/reports-v4/default-reports',
    '/campaign/vnext/reports-v4/my-reports/customized',
    '/campaign/vnext/reports-v4/my-reports/shared',
    '/campaign/vnext/reports-v4/create',
    '/campaign/vnext/reports-v4/edit',
    '/campaign/vnext/ads',
    '/campaign/vnext/keywords',
    '/campaign/vnext/adgroups',
    '/campaign/vnext/extensions',
    '/campaign/vnext/budgetcenter',
  ]);
  return DFMEnabledPaths;
}

export function isDFMEnabledForPath(path, serverContext, campaignType) {
  return _.some(getDFMEnabledPaths(serverContext, campaignType), DFMPath => path.includes(DFMPath));
}
